'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var iconStyles = require('../iconStyles.js');
var SvgIcon = require('../../node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ReferralAppIcon = function ReferralAppIcon(props) {
  return React__default["default"].createElement(SvgIcon["default"], _objectSpread({
    viewBox: "0 0 265 265"
  }, props), React__default["default"].createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, React__default["default"].createElement("rect", {
    style: {
      fill: "#fff"
    },
    x: "66.71",
    y: "45.29",
    width: "124.63",
    height: "157.03"
  }), React__default["default"].createElement("path", {
    style: {
      fill: "#2196f3"
    },
    d: "M128.86,105.42c-13.3,0-24.17-10.25-24.22-23s10.73-23.09,24-23.14,24.17,10.26,24.22,23S142.16,105.37,128.86,105.42ZM128.69,62c-11.74,0-21.25,9.2-21.21,20.41s9.63,20.3,21.37,20.26,21.25-9.2,21.21-20.41S140.43,62,128.69,62Z"
  }), React__default["default"].createElement("path", {
    style: {
      fill: "#2196f3"
    },
    d: "M136.32,86.2A6.8,6.8,0,0,1,135,90.43a3.39,3.39,0,0,1-.32.35,6.55,6.55,0,0,1-2.95,1.78l-.05,0,.07,3h-3.58v-3h-4.61l-1.81,0V85.39l1.92,0,0,.24A5.38,5.38,0,0,0,125.3,89a4.33,4.33,0,0,0,2.89,1.07h.63A2.88,2.88,0,0,0,131.17,89a2.44,2.44,0,0,0,.55-1.67,2,2,0,0,0-.51-1.31l-.08-.07a4.58,4.58,0,0,0-1.21-.86c-.34-.16-.78-.35-1.3-.55a4.72,4.72,0,0,0-.45-.16c-.17-.08-.36-.14-.54-.21A14.16,14.16,0,0,1,123,81.53a5.07,5.07,0,0,1-1.47-2.21,6.15,6.15,0,0,1-.32-1.9,5.77,5.77,0,0,1,.26-1.88,4.27,4.27,0,0,1,.28-.83,5.41,5.41,0,0,1,2-2.37,7.75,7.75,0,0,1,3.89-1.15h.52l-.05-2.94h3.54v3h3.06l0,7.11h-2.11a7.47,7.47,0,0,0-1-3,2.52,2.52,0,0,0-.4-.54,2.1,2.1,0,0,0-.38-.36,3.66,3.66,0,0,0-2.41-.75h-.11l-.28,0a2.66,2.66,0,0,0-1.63.67,2.26,2.26,0,0,0-.77,1.69,2.31,2.31,0,0,0,.31,1.37,3.25,3.25,0,0,0,1.23,1.07c.26.16.56.31.89.48.18.1.39.19.6.29l1.21.53c.49.21,1,.41,1.39.61l.38.18q.78.39,1.41.75a7.7,7.7,0,0,1,1.75,1.4c.14.16.29.33.46.54A4.89,4.89,0,0,1,136.32,86.2Z"
  }), React__default["default"].createElement("path", {
    style: {
      fill: "#2196f3"
    },
    d: "M167.53,113.63l-78.18.28.09-1.73c0-.16,0-.32,0-.48,0-8.29-6.86-14.93-15.54-15.12l-1.39,0-.11-28.8,1.38,0c8.66-.25,15.42-6.9,15.43-15.16V51.12l77.94-.28v1.42c.07,8.35,7.22,15.11,16,15.08h.15l.27,0,1.45,0,.12,28.94-1.46,0-.27,0h-.15c-8.77,0-15.88,6.88-15.84,15.26,0,.16,0,.32,0,.48Zm-75.24-2.44,72.27-.26c.23-9.34,8-16.94,17.71-17.45L182.18,70c-9.43-.42-17.06-7.53-17.8-16.47L92,53.82c-.63,8.71-7.66,15.63-16.75,16.52L75.36,94C84.76,94.79,92,102.09,92.29,111.19Z"
  }), React__default["default"].createElement("path", {
    style: {
      fill: "#2196f3"
    },
    d: "M192,122.29l-126.14.46-.31-78.23,126.14-.46ZM68.69,120l120.46-.44-.29-72.81L68.4,47.22Z"
  }), React__default["default"].createElement("path", {
    style: {
      fill: "#2196f3"
    },
    d: "M192.07,140.73l-126.14.46,0-11.53L192,129.2ZM68.76,138.46,189.22,138l0-6.1-120.46.43Z"
  }), React__default["default"].createElement("path", {
    style: {
      fill: "#2196f3"
    },
    d: "M192,131.3l-126.14.46-.05-11.52L192,119.78ZM68.72,129l120.47-.44,0-6.1-120.46.44Z"
  }), React__default["default"].createElement("path", {
    style: {
      fill: "#2196f3"
    },
    d: "M192.11,149,66,149.43l0-11.52,126.14-.46ZM68.79,146.71l120.47-.44,0-6.1-120.46.44Z"
  }), React__default["default"].createElement("path", {
    style: {
      fill: "#2196f3"
    },
    d: "M192.06,167.06l-126.14.46,0-11.53L192,155.54ZM68.75,164.8l120.46-.44,0-6.1-120.46.44Z"
  }), React__default["default"].createElement("path", {
    style: {
      fill: "#2196f3"
    },
    d: "M192,157.63l-126.14.46,0-11.52L192,146.11ZM68.71,155.37l120.47-.44,0-6.1-120.46.44Z"
  }), React__default["default"].createElement("path", {
    style: {
      fill: "#2196f3"
    },
    d: "M192.1,175.31,66,175.76l0-11.52,126.14-.46ZM68.78,173l120.47-.44,0-6.1-120.46.44Z"
  }), React__default["default"].createElement("path", {
    style: {
      fill: "#2196f3"
    },
    d: "M192.18,193.37,66,193.83l0-11.53,126.14-.45ZM68.87,191.11l120.46-.44,0-6.1L68.85,185Z"
  }), React__default["default"].createElement("path", {
    style: {
      fill: "#2196f3"
    },
    d: "M192.14,184,66,184.4,66,172.88l126.14-.46ZM68.83,181.68l120.47-.44,0-6.1-120.46.44Z"
  }), React__default["default"].createElement("path", {
    style: {
      fill: "#2196f3"
    },
    d: "M192.22,201.62l-126.14.46,0-11.53,126.14-.46ZM68.9,199.35l120.47-.43,0-6.1-120.46.43Z"
  }), React__default["default"].createElement("rect", {
    style: {
      fill: "#fff"
    },
    x: "61.05",
    y: "80.51",
    width: "48.04",
    height: "7.68",
    rx: "3.48"
  }), React__default["default"].createElement("rect", {
    style: {
      fill: "#fff"
    },
    x: "61.05",
    y: "91.42",
    width: "46.57",
    height: "6.59",
    rx: "3.18"
  }), React__default["default"].createElement("path", {
    style: {
      fill: "#2196f3"
    },
    d: "M141.81,172.4l-6.9-36.26a10.58,10.58,0,0,0-.71-3.78c-3.95-19.9-24.3-35.06-48.83-35.07s-44.9,15.14-48.86,35a10.58,10.58,0,0,0-.71,3.78l-6.93,36.26c-4.23,20.2-5.39,18-11.54,37.67v7.17a8.81,8.81,0,0,0,8.94,8.61H43.88l84,0h17.6a8.81,8.81,0,0,0,8.95-8.6v-7.17C149.1,192.61,144.49,190.39,141.81,172.4Z"
  }), React__default["default"].createElement("rect", {
    style: {
      fill: "#2196f3"
    },
    x: "61.04",
    y: "97.17",
    width: "48.04",
    height: "6.33",
    rx: "3.16"
  }), React__default["default"].createElement("rect", {
    style: {
      fill: "#2196f3"
    },
    x: "61.05",
    y: "75.33",
    width: "48.04",
    height: "6.33",
    rx: "3.16"
  }), React__default["default"].createElement("polygon", {
    style: {
      fill: "#2196f3"
    },
    points: "63.63 75.32 58.41 67.45 112.8 67.47 106.84 75.33 63.63 75.32"
  }), React__default["default"].createElement("rect", {
    style: {
      fill: "#2196f3"
    },
    x: "61.05",
    y: "86.25",
    width: "48.04",
    height: "6.33",
    rx: "3.16"
  }), React__default["default"].createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M105.29,174.81c.07,4.23-1.12,8.83-3.49,11.88a10.61,10.61,0,0,1-.85,1,17.39,17.39,0,0,1-8,5,.23.23,0,0,1-.14.07l.14,8.46H83.39v-8.43L71,192.7l-4.87.07.07-20.41,5.18-.1.1.68c.51,4.26,1.89,7.51,4.16,9.64a11.27,11.27,0,0,0,7.75,3,8.7,8.7,0,0,0,1,0c.23,0,.47,0,.67,0a8.69,8.69,0,0,0,5.66-2.19,8,8,0,0,0,.67-.75A7,7,0,0,0,92.9,178a5.43,5.43,0,0,0-1.35-3.69l-.2-.2a12.05,12.05,0,0,0-3.25-2.44c-.91-.44-2.1-1-3.49-1.56-.37-.17-.77-.31-1.21-.47s-1-.38-1.46-.58a37.85,37.85,0,0,1-12.38-7.55,14.54,14.54,0,0,1-3.93-6.23,18.72,18.72,0,0,1-.13-10.66,12.6,12.6,0,0,1,.78-2.34,15.23,15.23,0,0,1,5.45-6.63c2.61-1.86,6.13-2.91,10.5-3.21h1.38l-.1-8.29H93v8.33h8.23v20H95.55A21.84,21.84,0,0,0,93,144.08a9,9,0,0,0-1.08-1.53,7.44,7.44,0,0,0-1-1,9.61,9.61,0,0,0-6.46-2.14h-.31a5.47,5.47,0,0,0-.74.07,7,7,0,0,0-4.4,1.86,6.5,6.5,0,0,0-2.1,4.74,6.62,6.62,0,0,0,.81,3.86A9.09,9.09,0,0,0,81,153c.68.44,1.49.88,2.37,1.36.51.27,1,.54,1.63.81,1,.48,2.06,1,3.24,1.52s2.58,1.16,3.73,1.73l1,.51c1.42.75,2.67,1.46,3.79,2.13a20.35,20.35,0,0,1,4.7,4c.38.44.78.91,1.22,1.52A14.08,14.08,0,0,1,105.29,174.81Z"
  }), React__default["default"].createElement("rect", {
    style: {
      fill: "#fff"
    },
    x: "116.76",
    y: "138.64",
    width: "121.3",
    height: "87.63"
  }), React__default["default"].createElement("path", {
    style: {
      fill: "#2196f3"
    },
    d: "M177.24,199.9a23.48,23.48,0,1,1,23.39-23.57A23.5,23.5,0,0,1,177.24,199.9Zm-.17-44.2a20.72,20.72,0,1,0,20.8,20.64A20.74,20.74,0,0,0,177.07,155.7Z"
  }), React__default["default"].createElement("path", {
    style: {
      fill: "#2196f3"
    },
    d: "M184.49,180.32a7.1,7.1,0,0,1-1.24,4.3,3.47,3.47,0,0,1-.31.36,6.29,6.29,0,0,1-2.87,1.81.09.09,0,0,1,0,0l.06,3.06h-3.47l0-3h-4.48l-1.76,0v-7.39l1.87,0,0,.24a5.5,5.5,0,0,0,1.52,3.49,4.06,4.06,0,0,0,2.8,1.09h.62a3.13,3.13,0,0,0,2-.81,2.1,2.1,0,0,0,.24-.27,2.57,2.57,0,0,0,.54-1.7,2,2,0,0,0-.5-1.33l-.07-.08a4.62,4.62,0,0,0-1.18-.87c-.33-.16-.76-.36-1.27-.56l-.44-.17c-.16-.08-.34-.14-.52-.21a13.68,13.68,0,0,1-4.5-2.71,5.38,5.38,0,0,1-1.43-2.25,6.79,6.79,0,0,1-.06-3.86,4.6,4.6,0,0,1,.28-.84,5.37,5.37,0,0,1,2-2.41,7.33,7.33,0,0,1,3.79-1.18h.51l-.05-3,3.44,0v3h3l0,7.23h-2.05a8.09,8.09,0,0,0-.93-3,3.39,3.39,0,0,0-.4-.55,2.16,2.16,0,0,0-.37-.37,3.49,3.49,0,0,0-2.34-.76h-.11a1.18,1.18,0,0,0-.27,0,2.51,2.51,0,0,0-1.59.68,2.3,2.3,0,0,0-.75,1.71,2.37,2.37,0,0,0,.3,1.4,3.42,3.42,0,0,0,1.2,1.1c.25.15.54.31.86.48s.38.2.59.29c.36.17.75.36,1.18.55s.93.41,1.35.62l.37.18c.51.27,1,.53,1.37.77a7.31,7.31,0,0,1,1.71,1.42c.13.16.28.33.44.55A5.1,5.1,0,0,1,184.49,180.32Z"
  }), React__default["default"].createElement("path", {
    style: {
      fill: "#2196f3"
    },
    d: "M214.87,208.26l-76.09.29.09-1.76c0-.17,0-.33,0-.49a15.39,15.39,0,0,0-15.13-15.41l-1.35,0-.11-29.34,1.35,0a15.38,15.38,0,0,0,15-15.45v-1.45l75.85-.29v1.45a15.49,15.49,0,0,0,15.53,15.36h.42l1.41,0,.11,29.48-1.41,0h-.41A15.5,15.5,0,0,0,214.74,206l0,.49Zm-73.23-2.48,70.35-.27a18.26,18.26,0,0,1,17.23-17.78l-.09-23.89a18.27,18.27,0,0,1-17.32-16.78l-70.43.27a18.11,18.11,0,0,1-16.3,16.83l.09,24.05A18.12,18.12,0,0,1,141.64,205.78Z"
  }), React__default["default"].createElement("path", {
    style: {
      fill: "#2196f3"
    },
    d: "M238.69,217.09l-122.77.46-.3-79.7,122.77-.46Zm-120-2.31,117.25-.44-.29-74.18-117.24.44Z"
  }), React__default["default"].createElement("path", {
    style: {
      fill: "#2196f3"
    },
    d: "M238.73,226.27,116,226.73l0-11.74,122.77-.47Zm-120-2.31L236,223.51l0-6.21-117.25.44Z"
  }), React__default["default"].createElement("path", {
    style: {
      fill: "#2196f3"
    },
    d: "M206,69.42l.09-.27c7.52-.63,13.92-9,16.74-20.66,2.57,11.53,8.56,19.93,15.86,21.24l-.09.58c-7.2,1.2-13.16,9.25-15.84,20.46C220.08,78.8,213.65,70.16,206,69.42Z"
  }), React__default["default"].createElement("path", {
    style: {
      fill: "#2196f3"
    },
    d: "M200,107l.05-.14c4-.34,7.44-4.8,8.95-11,1.38,6.17,4.58,10.66,8.49,11.36l-.05.31c-3.85.64-7,5-8.47,11C207.55,112,204.11,107.4,200,107Z"
  })));
};

var ReferralAppIcon$1 = iconStyles()(ReferralAppIcon);

module.exports = ReferralAppIcon$1;
